module.exports = __webpack_public_path__ + "img/new2.25bfa466.png";